<template>
  <span :class="['skeleton', 'skeleton-loading']"></span>
</template>

<style lang="less" scoped>
@keyframes svgAnimation {
  0% {
    background-position-x: 125%;
  }

  100% {
    background-position-x: -32%;
  }
}

.skeleton {
  &-loading {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      from(var(--cms-text-color-secondary)),
      color-stop(var(--cms-text-color-secondary)),
      color-stop(var(--cms-text-color-secondary)),
      color-stop(var(--cms-theme-text-color-primary)),
      color-stop(var(--cms-text-color-secondary)),
      color-stop(var(--cms-text-color-secondary)),
      to(var(--cms-text-color-secondary))
    ) !important;
    background-image: linear-gradient(
      90deg,
      var(--cms-text-color-secondary),
      var(--cms-text-color-secondary),
      var(--cms-text-color-secondary),
      var(--cms-theme-text-color-primary),
      var(--cms-text-color-secondary),
      var(--cms-text-color-secondary),
      var(--cms-text-color-secondary)
    ) !important;
    background-size: 200% 100% !important;
    animation: svgAnimation 0.9s linear infinite;
    animation: svgAnimation 0.9s linear infinite;
    border-radius: 0.04rem;
    opacity: 0.5;
  }
}
</style>
